import * as React from "react";

import { useAppSelector } from "../../store/hooks";
import { SpecialBettingsParityEnum } from "../../enums";

import StakeNumber from "./StakeNumber";

const ParityBoard: React.FC = () => {
  const parityStakeMultipliers = useAppSelector(
    (state) => state.config.parityStakeMultipliers
  );

  return (
    <div className="single_number_row">
      <StakeNumber
        value={SpecialBettingsParityEnum.EVEN}
        stakes={parityStakeMultipliers}
      />
      <StakeNumber
        value={SpecialBettingsParityEnum.ODD}
        stakes={parityStakeMultipliers}
      />
    </div>
  );
};

export default ParityBoard;
